export const GET_ERRORS = 'GET_ERRORS';
export const GET_ERRORS2 = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const LOGIN_AUTH = 'LOGIN_AUTH';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const GET_PGM_LIST = 'GET_PGM_LIST';  
export const GET_PGM_DETAIL = 'GET_PGM_DETAIL';
export const GET_PGM_ROLES='GET_PGM_ROLES';
export const GET_USER_APPROVAL = 'GET_USER_APPROVAL';
export const POST_USER_DEACTIVATE = 'POST_USER_DEACTIVATE';
export const POST_NEED_CORRECTION = 'POST_NEED_CORRECTION';
export const POST_ADD_PARTNER = 'POST_ADD_PARTNER';
export const POST_CREATE_BUSINESS_CONTACT = 'POST_CREATE_BUSINESS_CONTACT';
export const POST_CREATE_QUESTIONNAIRE_DETAIL = 'POST_CREATE_QUESTIONNAIRE_DETAIL';
export const GET_QUESTIONAIRE_LIST = 'GET_QUESTIONAIRE_LIST';
export const GET_QUESTIONNAIR_CONFIG='GET_QUESTIONNAIR_CONFIG';
export const GET_ORDER_LIST = 'GET_ORDER_LIST';
export const GET_ORDER_VIEW_LIST = 'GET_ORDER_VIEW_LIST';
export const GET_MODULE_LIST = 'GET_MODULE_LIST';
export const GET_DETAILS_MODULE_LIST = 'GET_DETAILS_MODULE_LIST';
export const GET_PART_CATELOGUE_LIST = 'GET_PART_CATELOGUE_LIST';
export const GET_VEHCILE_CATEGORY_LIST = 'GET_VEHCILE_CATEGORY_LIST';
export const GET_EDIT_PART_CATELOGUE_LIST = 'GET_EDIT_PART_CATELOGUE_LIST';
export const GET_QUESTIONAIRE_DEATIL='GET_QUESTIONAIRE_DEATIL';
export const POST_SET_PASSWORD = 'POST_SET_PASSWORD';
export const GET_PART_LIST = 'GET_PART_LIST';
export const GET_VEHICLE_LIST = 'GET_VEHICLE_LIST';
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_DISTRIBUTORS_LIST = 'GET_DISTRIBUTORS_LIST';
export const GET_VERIFICATION_DOCUMENTS = 'GET_VERIFICATION_DOCUMENTS';
export const GET_EDIT_PART = 'GET_EDIT_PART';
export const GET_TUTORIAL_AND_TROUBLE='GET_TUTORIAL_AND_TROUBLE';
export const GET_CHECKED_UNCHECKED_TUTORIAL='GET_CHECKED_UNCHECKED_TUTORIAL';
export const GET_EDIT_TRAINING = 'GET_EDIT_TRAINING'
export const POST_ADD_CONTENT='POST_ADD_CONTENT';
export const POST_UPDATE_CONTENT='POST_UPDATE_CONTENT';
export const POST_ADD_MODULE='POST_ADD_MODULE';
export const PUT_UPDATE_MODULE='PUT_UPDATE_MODULE';
export const POST_CRETAE_PART='POST_CRETAE_PART';
export const POST_UPDATE_PART='POST_UPDATE_PART';
export const POST_CREATE_CATALOGE='POST_CREATE_CATALOGE';
export const PUT_UPDATE_CATALOGE='PUT_UPDATE_CATALOGE';
export const POST_CREATE_ORDER_STATUS='POST_CREATE_ORDER_STATUS';
export const GET_SECURITY_QUESTION_LIST='GET_SECURITY_QUESTION_LIST';
export const GET_DOWNLOAD_ORDER = 'GET_DOWNLOAD_ORDER';
export const GET_DOWNLOAD_PARTS = 'GET_DOWNLOAD_PARTS';
export const POST_ADD_BULK_PART = 'POST_ADD_BULK_PART';
export const POST_UPLOAD_BUSINESS_CONTACT_FILE='POST_UPLOAD_BUSINESS_CONTACT_FILE';
export const POST_DELETE_STORE_PHOTO='POST_DELETE_STORE_PHOTO';
export const PGM_SEARCH_DATA='PGM_SEARCH_DATA';
export const PGM_PAGE_VALUE='PGM_PAGE_VALUE';
export const GET_LOGIN_ROLE='GET_LOGIN_ROLE';
export const GET_ALL_LANGUAGE_LIST='GET_ALL_LANGUAGE_LIST';
export const TRAINING_BUTTON='TRAINING_BUTTON';
export const GET_ADDRESS_TOKEN='GET_ADDRESS_TOKEN';
export const GET_ADDRESS_SUGGESTION='GET_ADDRESS_SUGGESTION';
export const GET_ADDRESS_DETAILED='GET_ADDRESS_DETAILED';
export const PART_LIST_SEARCH_INPUT='PART_LIST_SEARCH_INPUT';
export const PART_LIST_PAGE_INPUT='PART_LIST_PAGE_INPUT';
export const PART_LIST_SORT='PART_LIST_SORT';
export const PART_CATALOGUE_PAGE_INPUT='PART_CATALOGUE_PAGE_INPUT';
export const TUTORIAL_LIST_SEARCH_INPUT='TUTORIAL_LIST_SEARCH_INPUT';
export const ORDER_LIST_SEARCH_INPUT='ORDER_LIST_SEARCH_INPUT';
export const ORDER_LIST_PAGE_INPUT='ORDER_LIST_PAGE_INPUT';
export const ORDER_LIST_SORT='ORDER_LIST_SORT';
export const SELECT_LANGUAGE_INPUT='SELECT_LANGUAGE_INPUT';
export const MODULE_LIST_SEARCH_INPUT='MODULE_LIST_SEARCH_INPUT';
export const MODULE_LIST_PAGE_VALUE='MODULE_LIST_PAGE_VALUE';
export const TUTORIAL_LIST_PAGE_VALUE='TUTORIAL_LIST_PAGE_VALUE';
export const PGM_FILTER_BUTTON_VALUE='PGM_FILTER_BUTTON_VALUE';
export const POST_LAT_LONG_AUTH_RESPONSE='POST_LAT_LONG_AUTH_RESPONSE';   //ONLY FOR UAT REVERT AFTER RESOLVE LAT LONG API ON  UAT ISSUES
export const POST_FORGET_PASSWORD='POST_FORGET_PASSWORD';
export const POST_RESET_PASSWORD='POST_RESET_PASSWORD';
//Roles and Permission
export const FETCH_PERMISSIONS_REQUEST = 'FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = 'FETCH_PERMISSIONS_FAILURE';
//get states
export const GET_STATES_REQUEST = 'GET_STATES_REQUEST';
export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES_FAILURE = 'GET_STATES_FAILURE';
//get role data
export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST'
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS'
export const GET_ROLE_FAILURE = 'GET_ROLE_FAILURE'
//Create Role Permission
export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAILURE = 'CREATE_ROLE_FAILURE';
//Delete Role and Permission
export const DELETE_ROLE_REQUEST = "DELETE_ROLE_REQUEST";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAILURE = "DELETE_ROLE_FAILURE";
//Get edit role details
export const GET_ROLE_DETAIL_SUCCESS = "GET_ROLE_DETAIL_SUCCESS";
export const GET_ROLE_DETAIL_FAILURE = "GET_ROLE_DETAIL_FAILURE";
//Update role Details
export const UPDATE_ROLE_PERMISSION_REQUEST = 'UPDATE_ROLE_PERMISSION_REQUEST';
export const UPDATE_ROLE_PERMISSION_SUCCESS = "GET_ROLE_DETAIL_SUCCESS";
export const UPDATE_ROLE_PERMISSION_FAILURE = "GET_ROLE_DETAIL_FAILURE";
//Create User Permission
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
//get user list
export const FETCH_EMPLOYEE_REQUEST = 'FETCH_EMPLOYEE_REQUEST';
export const FETCH_EMPLOYEE_SUCCESS = 'FETCH_EMPLOYEE_SUCCESS';
export const FETCH_EMPLOYEE_FAILURE = 'FETCH_EMPLOYEE_FAILURE';
//get user details for update
export const USER_DETAIL_REQUEST = 'USER_DETAIL_REQUEST'
export const USER_DETAIL_SUCCESS = 'USER_DETAIL_SUCCESS'
export const USER_DETAIL_FAILURE = 'USER_DETAIL_FAILURE'
//Delete User
export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";
//Update User
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
//Switch Toggle for User
export const TOGGLE_USER_STATUS_REQUEST = 'TOGGLE_USER_STATUS_REQUEST';
export const TOGGLE_USER_STATUS_SUCCESS = "TOGGLE_USER_STATUS_SUCCESS"
export const TOGGLE_USER_STATUS_FAILURE = "TOGGLE_USER_STATUS_FAILURE"

//Area Executive

//Create Area Executive
export const CREATE_AREA_EXECUTIVE_REQUEST = 'CCREATE_AREA_EXECUTIVE_REQUEST';
export const CREATE_AREA_EXECUTIVE_SUCCESS = 'CCREATE_AREA_EXECUTIVE_SUCCESS';
export const CREATE_AREA_EXECUTIVE_FAILURE = 'CCREATE_AREA_EXECUTIVE_FAILURE';

//get area executive list
export const FETCH_AREA_EXECUTIVE_REQUEST = 'FETCH_AREA_EXECUTIVE_REQUEST';
export const FETCH_AREA_EXECUTIVE_SUCCESS = 'FETCH_AREA_EXECUTIVE_SUCCESS';
export const FETCH_AREA_EXECUTIVE_FAILURE = 'FETCH_AREA_EXECUTIVE_FAILURE';

//delete area executive
export const DELETE_AREA_EXECUTIVE_REQUEST = "DELETE_AREA_EXECUTIVE_REQUEST";
export const DELETE_AREA_EXECUTIVE_SUCCESS = "DELETE_AREA_EXECUTIVE_SUCCESS";
export const DELETE_AREA_EXECUTIVE_FAILURE = "DELETE_AREA_EXECUTIVE_FAILURE";

//get Area Executive details for update
export const AREA_EXECUTIVE_DETAIL_REQUEST = 'AREA_EXECUTIVE_DETAIL_REQUEST'
export const AREA_EXECUTIVE_DETAIL_SUCCESS = 'AREA_EXECUTIVE_DETAIL_SUCCESS'
export const AREA_EXECUTIVE_DETAIL_FAILURE = 'AREA_EXECUTIVE_DETAIL_FAILURE'

//Update Area Executive
export const UPDATE_AREA_EXECUTIVE_SUCCESS = "UPDATE_AREA_EXECUTIVE_SUCCESS";
export const UPDATE_AREA_EXECUTIVE_FAILURE = "UPDATE_AREA_EXECUTIVE_FAILURE";

//Switch Toggle for Area Executive
export const TOGGLE_AREA_EXECUTIVE_STATUS_REQUEST = "TOGGLE_AREA_EXECUTIVE_STATUS_REQUEST";
export const TOGGLE_AREA_EXECUTIVE_STATUS_SUCCESS = "TOGGLE_AREA_EXECUTIVE_STATUS_SUCCESS";
export const TOGGLE_AREA_EXECUTIVE_STATUS_FAILURE = "TOGGLE_AREA_EXECUTIVE_STATUS_FAILURE";

//Get Group Data
export const FETCH_GROUP_DATA_REQUEST = 'FETCH_GROUP_DATA_REQUEST';
export const FETCH_GROUP_DATA_SUCCESS = 'FETCH_GROUP_DATA_SUCCESS';
export const FETCH_GROUP_DATA_FAILURE = 'FETCH_GROUP_DATA_FAILURE';

//Update Group Data
export const UPDATE_DISCOUNT_GROUP_REQUEST = 'UPDATE_DISCOUNT_GROUP_REQUEST'
export const UPDATE_DISCOUNT_GROUP_SUCCESS = 'UPDATE_DISCOUNT_GROUP_SUCCESS'
export const UPDATE_DISCOUNT_GROUP_FAILURE = 'UPDATE_DISCOUNT_GROUP_FAILURE'

//get Notification List
export const NOTIFICATION_LIST_REQUEST = 'NOTIFICATION_LIST_REQUEST';
export const NOTIFICATION_LIST_SUCCESS = 'NOTIFICATION_LIST_SUCCESS';
export const NOTIFICATION_LIST_FAIL = 'NOTIFICATION_LIST_FAIL';

//Create Notification constants
export const CREATE_SCHEDULE_NOTIFICATION_REQUEST = 'CREATE_SCHEDULE_NOTIFICATION_REQUEST'
export const CREATE_SCHEDULE_NOTIFICATION_SUCCESS = 'CREATE_SCHEDULE_NOTIFICATION_SUCCESS'
export const CREATE_SCHEDULE_NOTIFICATION_FAILURE = 'CREATE_SCHEDULE_NOTIFICATION_FAILURE'

//Update Notification constants
export const UPDATE_SCHEDULE_NOTIFICATION_REQUEST = 'UPDATE_SCHEDULE_NOTIFICATION_REQUEST'
export const UPDATE_SCHEDULE_NOTIFICATION_SUCCESS = 'UPDATE_SCHEDULE_NOTIFICATION_SUCCESS'
export const UPDATE_SCHEDULE_NOTIFICATION_FAILURE = 'UPDATE_SCHEDULE_NOTIFICATION_FAILURE'

//Update Bulk Notification constants
export const UPDATE_BULK_SCHEDULE_NOTIFICATION_REQUEST = 'UPDATE_BULK_SCHEDULE_NOTIFICATION_REQUEST'
export const UPDATE_BULK_SCHEDULE_NOTIFICATION_SUCCESS = 'UPDATE_BULK_SCHEDULE_NOTIFICATION_SUCCESS'
export const UPDATE_BULK_SCHEDULE_NOTIFICATION_FAILURE = 'UPDATE_BULK_SCHEDULE_NOTIFICATION_FAILURE'

//Create Bulk Notification constants
export const CREATE_BULK_SCHEDULE_NOTIFICATION_REQUEST = 'CREATE_BULK_SCHEDULE_NOTIFICATION_REQUEST'
export const CREATE_BULK_SCHEDULE_NOTIFICATION_SUCCESS = 'CREATE_BULK_SCHEDULE_NOTIFICATION_SUCCESS'
export const CREATE_BULK_SCHEDULE_NOTIFICATION_FAILURE = 'CREATE_BULK_SCHEDULE_NOTIFICATION_FAILURE'

//get details of notification for edit
export const NOTIFICATION_DETAILS_REQUEST = 'NOTIFICATION_DETAILS_REQUEST';
export const NOTIFICATION_DETAILS_SUCCESS = 'NOTIFICATION_DETAILS_SUCCESS';
export const NOTIFICATION_DETAILS_FAIL = 'NOTIFICATION_DETAILS_FAIL';

//get details of Bulk notification for edit
export const BULK_NOTIFICATION_DETAILS_REQUEST = 'BULK_NOTIFICATION_DETAILS_REQUEST';
export const BULK_NOTIFICATION_DETAILS_SUCCESS = 'BULK_NOTIFICATION_DETAILS_SUCCESS';
export const BULK_NOTIFICATION_DETAILS_FAIL = 'BULK_NOTIFICATION_DETAILS_FAIL';

//get user group list
export const USER_GROUP_REQUEST = 'USER_GROUP_REQUEST';
export const USER_GROUP_SUCCESS = 'USER_GROUP_SUCCESS';
export const USER_GROUP_FAIL = 'USER_GROUP_FAIL';

//get redirection page list
export const REDIRECTION_PAGE_REQUEST = 'REDIRECTION_PAGE_REQUEST';
export const REDIRECTION_PAGE_SUCCESS = 'REDIRECTION_PAGE_SUCCESS';
export const REDIRECTION_PAGE_FAIL = 'REDIRECTION_PAGE_FAIL';
